module.exports = __webpack_public_path__ + "media/images/covers/login-cover-3e4ffa01e0c80ff5af5e79b54fdd735b.jpg";